module.exports = __webpack_public_path__ + "img/nav-design-modern@2x.08458c0.jpg";